import { getTokenUrl, loginUrl, getJwtToken } from "../config";
import { DateTime } from "luxon";
import { ContextService } from "./index";

class JwtService {
  parseJwt = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  };

  isJwtValid: () => boolean = () => {
    const jwt = getJwtToken();
    if (!jwt) return false;
    let expDate;
    try {
      const token = this.parseJwt(jwt);
      expDate = DateTime.fromMillis(token.exp * 1000);
    } catch (e) {}
    return DateTime.now() < expDate;
  };

  updateJwt(): Promise<string> {
    const url = getTokenUrl;
    return fetch(url, {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      if (!response.ok) {
        window.location.href = loginUrl;
      }
      // FIXME: save jwt in session storage?
      const _jwt = await response.json();
      if (!window["token"]) {
        window["token"] = {};
      }
      window["token"]._jwt = _jwt;
      return _jwt;
    });
  }

  async validateJwt(): Promise<void> {
    if (!this.isJwtValid() && !ContextService.isAnonymous()) {
      await this.updateJwt();
    }
  }
}

export default new JwtService();
